import { ShopIntegrationService } from "./lib/ShopIntegrationService";
import { tracking } from "./lib/Tracking";

const shopIntegration = new ShopIntegrationService();

(async () => {
    const isChatbotVisible = await shopIntegration.isChatbotEntryPointVisible();
    if (isChatbotVisible) {
        tracking.submitMerge({
            san_ChatBotView: ["true"],
        });
    }
})();
